import React from "react";

const Footer = () => {
  return (
    <div id="footer">
      <span>© {new Date().getFullYear()} HID Global Corporation/ASSA ABLOY. All rights reserved.</span>
      <span>|</span>
      <span>
        <a className="sisp-link" href="https://www.hidglobal.com/about/privacy/hid-origo-management-portal-privacy-notice" rel="noopener noreferrer" target="_blank">
          Privacy Notice
        </a>
      </span>
    </div>
  );
};

export default Footer;
